import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import library from "../../Assets/Projects/library.jpg";
import emotion from "../../Assets/Projects/emotion.png";
import Ecommerce from "../../Assets/Projects/e-com.PNG";
import cafe from "../../Assets/Projects/cafe.PNG";
import suicide from "../../Assets/Projects/Ai For Colour Recognition.webp";
import s4share from "../../Assets/Projects/s4share.PNG";
import Blogvibes from "../../Assets/Projects/blogvibes.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={cafe}
              isBlog={false}
              title="Cafe ERA (Table booking Application)"
              description="Cafe ERA is a table booking application that allows users to book a table at their favorite cafe. With an easy-to-use interface, users can select a table and the location of the cafe. This application simplifies the process of making a reservation, making it convenient and hassle-free for users"
              ghLink="https://github.com/SoheelGadad/cafe-site"
              demoLink="https://client-9x38.onrender.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Ecommerce}
              isBlog={false}
              title="E-commerce Application"
              description="E-commerce applications built with React and Node.js allow businesses to create online stores with dynamic interfaces, robust backend functionality, and secure payment processing. These applications enable customers to browse and purchase products, view order history, and manage their accounts. With the flexibility and scalability of React and Node.js, businesses can easily customize their e-commerce platforms to meet their specific needs and keep up with evolving customer demands.."
              ghLink="https://github.com/SoheelGadad"
              demoLink="https://khankk4916.wixsite.com/sweetparadise2"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={s4share}
              isBlog={false}
              title="S4Share"
              description="S4Share is a user-friendly platform that allows users to easily share files and documents. With S4Share, users can upload their files and share them with anyone they choose, without having to worry about file size limits or complicated sharing processes"
              ghLink="https://github.com/SoheelGadad/filesharing"
              demoLink="https://soheelgadad.github.io/filesharing/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={library}
              isBlog={false}
              title="CLibrary"
              description="Our library offers over 100 books on different topics and is built using React and Node.js. Users can browse the collection and check out books, and the system keeps track of borrowing history and due dates."
              ghLink="https://github.com/SoheelGadad/Clibrary"
              demoLink="/comingsoon"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Ai For Colour Recognition"
              description="AI for color recognition uses algorithms and machine learning to recognize and identify colors in images or videos. This technology is used in a variety of applications, including design, manufacturing, and accessibility. With AI, color recognition can be done quickly and accurately, allowing for more efficient and effective color-related tasks."
              ghLink="https://github.com/soumyajit4419/AI_For_Social_Good"
              demoLink="/comingsoon"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Face Recognition and Emotion Detection"
              description="Trained a CNN classifier using 'FER-2013 dataset' with Keras and tensorflow backened. The classifier sucessfully predicted the various types of emotions of human. And the highest accuracy obtained with the model was 60.1%.
              Then used Open-CV to detect the face in an image and then pass the face to the classifer to predict the emotion of a person."
              ghLink="/comingsoon"
              demoLink="/comingsoon"
            />
          </Col>
        </Row>
        <h1 className="project-heading">
          My Recent <strong className="purple">No Code Project </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row>  
        <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Ecommerce}
              isBlog={false}
              title="E-commerce Application by Wix"
              description="E-commerce applications built with Wix allow businesses to create online stores with dynamic interfaces, robust backend functionality, and secure payment processing. These applications enable customers to browse and purchase products, view order history, and manage their accounts. With the flexibility and scalability of React and Node.js, businesses can easily customize their e-commerce platforms to meet their specific needs and keep up with evolving customer demands.."
              // ghLink="https://github.com/SoheelGadad"
              demoLink="https://khankk4916.wixsite.com/sweetparadise2"
            />
          </Col>
        <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Blogvibes}
              isBlog={false}
              title="Blog Application by webflow"
              description="A blog website using Webflow allows users to create and share written content. It includes a homepage with a list of articles, search bar, and category/tags links. Users can publish their own articles and customize the layout, colors, and typography. It may also have features like social sharing, commenting, and email newsletter sign-up forms."
              // ghLink="https://github.com/SoheelGadad"
              demoLink="https://blogvibes.webflow.io"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
